import { SPPurchase } from "../SPPurchase";

/**
 * SPOpenBet defines SP bet for Open bets  purchase.
 *
 * @typedef SPOpenBet
 * @type {Object}
 * @property {betId} Unique Id in the bet
 * @property {statusId} Determines is the bet open/won/lost etc.
 * @property {generatedId} Unique id of the bet in the purchase (1,2 etc. )
 * @property {currentBalance} current return of the bet
 * @property {deadHeatDeposit} Was there a dead heat applied to the deposit and how much
 * @property {commission} commission of the bet
 * @property {profitLoss} profitLoss of the bet
 * @property {percentDeduction} This is used for HR for withdrawn horses. You might get  lower odds.
 * @property {purchase} to which purchase this bet belongs
 * @property {mapping} Array of mapping needed for some bet types
 * @property {clientOdds} Odds in the client OddsStyle
 * @property {numberOfBets} Number of bets
 * @property {betSubType} Used in cast bettypes and other to determine the sub type of the bet (combination/straight forecast etc.)
 * @property {betTypeId} Used to determine type of bet (combo, single, teaser etc.)
 * @property {comboSize} determines the size of the combo
 * @property {betName} Name of the bet
 * @property {relatedToId} Used to show related free bet or EW bet if there is one
 * @property {deposit} Deposit of the bet
 * @property {gain} Gain of the bet
 * @property {odds} Odds of the bet
 * @property {dividend} fractional odds divident
 * @property {divisor} fractional odds divisor
 */

export class SPOpenBet {
    betId: number;
    generatedId: number;
    statusId: number;
    currentBalance: number;
    deadHeatDeposit: number;
    commission: number;
    profitLoss: number;
    percentDeduction: number;
    purchase?: SPPurchase;
    mapping: number[];
    clientOdds: number | string;
    numberOfBets: number;
    betSubType: number;
    betTypeId: number;
    comboSize: number;
    betName: string;
    relatedToId?: number;
    deposit: number;
    gain: number;
    odds: number;
    isFreeBet: boolean;
    isRiskFreeBet: boolean;
    dividend?: number;
    divisor?: number;
    freeBetBonusId?: number;

    constructor(source: SPOpenBet) {
        this.betId = source.betId;
        this.generatedId = source.generatedId;
        this.statusId = source.statusId;
        this.currentBalance = source.currentBalance;
        this.deadHeatDeposit = source.deadHeatDeposit;
        this.commission = source.commission;
        this.profitLoss = source.profitLoss;
        this.percentDeduction = source.percentDeduction;
        this.purchase = source.purchase;
        this.mapping = source.mapping;
        this.clientOdds = source.clientOdds;
        this.numberOfBets = source.numberOfBets;
        this.betSubType = source.betSubType;
        this.betTypeId = source.betTypeId;
        this.comboSize = source.comboSize;
        this.betName = source.betName;
        this.relatedToId = source.relatedToId;
        this.deposit = source.deposit;
        this.gain = source.gain;
        this.odds = source.odds;
        this.dividend = source.dividend;
        this.divisor = source.divisor;
        this.freeBetBonusId = source.freeBetBonusId;
        this.isFreeBet = source.isFreeBet;
        this.isRiskFreeBet = source.isRiskFreeBet;
    }
}